import React, { useState, useEffect, useCallback, CSSProperties } from 'react';

import UIcon from '../UIcon/UIcon';
import styles from './UHourStepper.style';

export type UHourStepperProps = {
  interval: number;
  style?: CSSProperties;
  onTimeChange: (time: Date) => void;
  value?: Date;
  dataTestContext?: string;
};

const HourStepper = ({ interval, style, onTimeChange, value, dataTestContext = '' }: UHourStepperProps) => {
  const initialTime = value || new Date(0, 0, 0, 10, 0);
  const [time, setTime] = useState(initialTime);

  useEffect(() => {
    onTimeChange(time);
  }, [time]);

  const formatTime = (date: Date): string => {
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  };

  const incrementTime = useCallback(() => {
    setTime((prevTime) => new Date(prevTime.getTime() + interval * 60000));
  }, [interval]);

  const decrementTime = useCallback(() => {
    setTime((prevTime) => new Date(prevTime.getTime() - interval * 60000));
  }, [interval]);

  return (
    <div style={{ ...styles.container, ...style }} data-test-id="hour-stepper-container">
      <button
        style={{ ...styles.button, ...styles.buttonDecrement }}
        onClick={decrementTime}
        data-test-id={`${dataTestContext}-hour-decrement-button`}
      >
        <UIcon size={8} name="minus" />
      </button>
      <div style={styles.time} data-test-id="time-display">
        {formatTime(time)}
      </div>
      <button
        style={{ ...styles.button, ...styles.buttonIncrement }}
        onClick={incrementTime}
        data-test-id={`${dataTestContext}-hour-increment-button`}
      >
        <UIcon size={8} name="plus" />
      </button>
    </div>
  );
};

export default HourStepper;
